import update from "immutability-helper";
import _ from "lodash";

import {
  //Редактирование формы шаблона
  SET_TEMPLATE_NAME,
  TOGGLE_TEMPLATE_BY_DEFAULT,
  //Загрузка информации о шаблоне
  EDITING_TEMPLATE_LOADING_START,
  EDITING_TEMPLATE_LOADED_SUCCESSFULLY, 
  EDITING_TEMPLATE_LOADING_FAILED,
  //Редактирование шаблона
  TEMPLATE_EDITING_START,
  TEMPLATE_EDITED_SUCCESSFULLY,
  TEMPLATE_EDITING_FAILED,
  //Создание шаблона
  TEMPLATE_CREATION_START,
  TEMPLATE_CREATED_SUCCESSFULLY,
  TEMPLATE_CREATION_FAILED,
  //Загрузка картинки
  TEMPLATE_IMAGE_UPLOAD_START,
  TEMPLATE_IMAGE_UPLOADED_SUCCESSFULLY,
  TEMPLATE_IMAGE_UPLOAD_FAILED,
  DELETE_TEMPLATE_IMAGE,
  //Другое
  CLEAR_TEMPLATE_FORM,
} from "../actions/editTemplate";

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: true,
  loading: false,
  template: {
    id: 0,
    name: '',
    thumbnail: null,
    is_default: false,
  },
  oldIsDefault: false,
  fileName: '',
  fileLoading: false,
  fileReady: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Редактирование и создание шаблона
    case EDITING_TEMPLATE_LOADED_SUCCESSFULLY:
      let loadedTemplate = action.payload.template;
      const urlPieces = action.payload.template 
        && action.payload.template.thumbnail 
        && action.payload.template.thumbnail.url 
        && action.payload.template.thumbnail.url.split("/");
      const fileName = urlPieces[urlPieces.length - 1];
      loadedTemplate = _.omit(loadedTemplate, ['created_at', 'is_enabled']);
      return {
        ...state,
        ready: true,
        loading: false,
        template: loadedTemplate,
        oldIsDefault: loadedTemplate.is_default,
        fileName: fileName,
        fileLoading: false,
        fileReady: true,
      };
    case EDITING_TEMPLATE_LOADING_FAILED:
    case TEMPLATE_EDITING_FAILED:
    case TEMPLATE_CREATION_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Редактирование шаблона
    case EDITING_TEMPLATE_LOADING_START:
    case TEMPLATE_EDITING_START:
    case TEMPLATE_CREATION_START:
      return {
        ...state,
        ready: false, 
        loading: true,
      };
    case TEMPLATE_EDITED_SUCCESSFULLY:
    case TEMPLATE_CREATED_SUCCESSFULLY:
    case CLEAR_TEMPLATE_FORM:
      return INITIAL_STATE;
    //Редактирование формы шаблона визитки
    case SET_TEMPLATE_NAME:
      return update(state, {
        template: {
          name: {$set: action.payload.value},
        }
      });
    case TOGGLE_TEMPLATE_BY_DEFAULT:
      return update(state, {
        template: {
          is_default: {$set: !state.template.is_default},
        }
      });
    //Загрузка картинки
    case TEMPLATE_IMAGE_UPLOAD_START:
      return {
        ...state,
        fileName: '',
        fileLoading: true,
        fileReady: false,
      };
    case TEMPLATE_IMAGE_UPLOADED_SUCCESSFULLY:
      return update(state, {
        template: {
          thumbnail: {$set: action.payload.templateFile},
        },
        fileName: {$set: action.payload.fileName},
        fileLoading: {$set: false},
        fileReady: {$set: true}
      });
    case TEMPLATE_IMAGE_UPLOAD_FAILED:
      return {
        ...state,
        fileLoading: false,
      };
    case DELETE_TEMPLATE_IMAGE:
      return update(state, {
        template: {
          thumbnail: {$set: null},
        },
        fileName: {$set: ''},
        fileReady: {$set: false}
      });
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
